import { Menu, TableColumnsType } from 'antd';
import moment from 'moment';
import { styled } from 'styled-components';
import { flexMixin, textMixin } from '@styles/mixins';
import { ECallStatus } from '@utils';
import { IAtsUserData, ICalls } from '@entities/booking/types';
import { Icons } from '@assets';
import { AppDispatch } from '@config/store';
import { getCalls } from '@api/thunks/booking';
import React from 'react';
import { FilterDropdownProps } from 'antd/es/table/interface';
import { PlayCircleOutlined } from '@ant-design/icons';
import { colors } from '@styles';
import ReactPlayer from 'react-player';

export const getCallColumns = (
    atsUsersData: IAtsUserData[],
    shop_id: number | undefined,
    dispatch: AppDispatch,
    handlerClickId: (
        id: number,
        e: React.MouseEvent<HTMLSpanElement, MouseEvent>
    ) => void,
    onRecordClick?: (call: ICalls) => void
): TableColumnsType<ICalls> => {
    return [
        {
            title: <div style={{ marginLeft: '5px' }}>Дата звонка</div>,
            dataIndex: 'date',
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
            width: '15%',

            render: record => {
                return (
                    <DateWrapper>
                        <StyledSpan>
                            {record ? moment(record).format('DD.MM.YYYY') : '-'}
                        </StyledSpan>
                        <StyledSpan>
                            {record ? moment(record).format('HH:mm:ss') : '-'}
                        </StyledSpan>
                    </DateWrapper>
                );
            },
        },

        {
            title: 'ФИО',
            dataIndex: 'user',
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
            width: '20%',

            filterDropdown: ({ confirm }: FilterDropdownProps) => {
                const handleMenuClick = (e: any) => {
                    const params = e.key !== 'all' ? { user: e.key } : {};

                    if (shop_id) {
                        dispatch(getCalls({ shop_id, params }));
                    }
                    confirm();
                };

                return (
                    <div style={{ padding: 8 }}>
                        <Menu
                            onClick={handleMenuClick}
                            items={[
                                { login: 'all', name: 'Все', role: 'admin' },
                                ...atsUsersData,
                            ]?.map((user: IAtsUserData) => ({
                                key: user.login,
                                label: user.name,
                            }))}
                        />
                    </div>
                );
            },

            render: (user: string) => {
                if (!user) return '-';
                return <TextWrapper>{user}</TextWrapper>;
            },
        },
        {
            title: 'Телефон',
            dataIndex: 'phone',
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
            width: '20%',
            align: 'center',
            render: (phone: string, record: ICalls) =>
                !record?.client_id ? (
                    <TextWrapper>{phone}</TextWrapper>
                ) : (
                    <StyledLink
                        onClick={e => handlerClickId(record.client_id!, e)}
                        role="button"
                        tabIndex={0}
                    >
                        {phone}
                    </StyledLink>
                ),
        },
        {
            title: 'Статус',
            dataIndex: 'status',
            align: 'center',
            width: '10%',
            filters: [
                {
                    text: 'успешные',
                    value: 'success',
                },
                {
                    text: 'пропущенные',
                    value: 'missed',
                },
                {
                    text: 'неотвеченные',
                    value: 'noanswer',
                },
            ],
            onFilter: (value, record) => record.status === value,
            render: (status: ECallStatus) => {
                return (
                    <TextWrapper>
                        {status === ECallStatus.SUCCESS ? (
                            <img src={Icons.CircleCheck} alt="icon search" />
                        ) : (
                            <img src={Icons.CircleMissed} alt="icon search" />
                        )}
                    </TextWrapper>
                );
            },
        },
        {
            title: 'Запись',
            dataIndex: 'record',
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
            width: '25%',
            align: 'center',
            render: (record: string | null, call: ICalls) => {
                return record ? (
                    // <RecordWrapper>
                    //     <PlayCircleOutlined
                    //         onClick={() => onRecordClick && onRecordClick(call)}
                    //     />
                    // </RecordWrapper>
                    <RecordWrapper>
                        <ReactPlayer
                            src={record}
                            controls
                            width="150px"
                            slot="media"
                            height="50px"
                            onError={() => console.log('Error player')}
                        />
                    </RecordWrapper>
                ) : (
                    <TextWrapper>Нет записи</TextWrapper>
                );
            },
        },
    ];
};
const StyledSpan = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    display: block;
    width: 100%;
    ${flexMixin('column', 'center', 'flex-start')};
`;

const TextWrapper = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 500,
    })};
`;

const DateWrapper = styled.div`
    ${flexMixin('column', 'center', 'flex-start')};
    flex-wrap: wrap;
    margin-left: 5px;
`;

const RecordWrapper = styled.div`
    ${flexMixin('column', 'center', 'center')};
    ${textMixin({
        fontSize: '14px',
        fontWeight: 500,
    })};
    & svg {
        width: 34px;
        height: 34px;
        color: ${colors.grey};
    }
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        & svg {
            color: ${colors.primaryBg};
        }
    }

    &:active {
        transform: scale(0.95);
    }
`;
const StyledLink = styled.a`
    cursor: pointer;
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    color: #1677ff;
`;
